import moment from "moment";

interface FilterData {
  path: string;
  filters: any;
  date: any;
}

// export function saveFiltersDataToLocalStorage(filterData: any) {
//   const currentTime = moment().valueOf().toString();
//   const storedFilters = localStorage.getItem("filtersData");
//   const filtersArray: FilterData[] = storedFilters
//     ? JSON.parse(storedFilters)
//     : [];

//   const filterIndex = filtersArray.findIndex(
//     (filter) => filter.path === window.location.pathname
//   );

//   const updatedData = { ...filterData };
//   delete updatedData.status;
//   // delete updatedData.type;
//   if (filterIndex > -1) {
//     filtersArray[filterIndex] = {
//       path: window.location.pathname,
//       date: currentTime,
//       filters: {
//         ...updatedData,
//         sortBy: "",
//         sortType: "",
//         page: 1,
//         limit: 10,
//         viewType: "list",
//       },
//     };
//   } else {
//     filtersArray.push({
//       path: window.location.pathname,
//       date: currentTime,
//       filters: {
//         ...updatedData,
//         sortBy: "",
//         sortType: "",
//         page: 1,
//         limit: 10,
//         viewType: "list",
//       },
//     });
//   }

//   localStorage.setItem("filtersData", JSON.stringify(filtersArray));
// }

export function saveFiltersDataToLocalStorage(filterData: any) {
  const currentTime = moment().valueOf().toString();
  const storedFilters = localStorage.getItem("filtersData");
  const filtersArray: FilterData[] = storedFilters
    ? JSON.parse(storedFilters)
    : [];

  console.log(window.location.search);
  // include both pathname and search (query string)
  const fullPath = window.location.pathname + window.location.search;

  const filterIndex = filtersArray.findIndex(
    (filter) => filter.path === fullPath
  );

  const updatedData = { ...filterData };
  delete updatedData.status;
  // delete updatedData.type;

  const newEntry: FilterData = {
    path: fullPath,
    date: currentTime,
    filters: {
      ...updatedData,
      sortBy: "",
      sortType: "",
      page: 1,
      limit: 10,
      viewType: "list",
    },
  };

  if (filterIndex > -1) {
    filtersArray[filterIndex] = newEntry;
  } else {
    filtersArray.push(newEntry);
  }

  localStorage.setItem("filtersData", JSON.stringify(filtersArray));
}

export function getFiltersDataFromLocalStorage(): FilterData | undefined {
  const storedFilters = localStorage.getItem("filtersData");

  const returivedFilters = storedFilters ? JSON.parse(storedFilters) : [];
  const fullPath = window.location.pathname + window.location.search;

  return returivedFilters.find(
    (filter: FilterData) => filter.path === fullPath
  );
}

export function removeExpiredFiltersFromLocalStorage() {
  const storedFilters = localStorage.getItem("filtersData");
  const retrievedFilters: any[] = storedFilters
    ? JSON.parse(storedFilters)
    : [];

  const updatedFilters = retrievedFilters.reduce((acc, filter: FilterData) => {
    if (!shouldClearFilter(filter.date)) {
      acc.push(filter);
    }
    return acc;
  }, []);

  localStorage.setItem("filtersData", JSON.stringify(updatedFilters));
}

function shouldClearFilter(time: string): boolean {
  const filterTimeMoment = moment(parseInt(time));
  const minutesSinceDismissed = moment().diff(filterTimeMoment, "minutes");
  return minutesSinceDismissed >= 30;
}
